export default __webpack_public_path__ + "static/media/icon-back.b37b7207.svg";